export const currencySymbols = { USD: "$", INR: "₹" };
